interface MenuItem {
    headTitle1?: string;
    headTitle2?: string;
    title?: string;
    icon?: string;
    icon1?: string;
    type: string;
    badgeType?: string;
    active?: boolean;
    isPinned?: boolean;
    path?: string;
    bagde?: string,
    children?: MenuItem[];
    bookmark?: boolean;
}

export function setupMenu(data: MenuItem[]) {
    localStorage.removeItem('menu-auth');
    const menuPaths = data.flatMap(item => {
        let paths: string[] = [];
        if (item.path) paths.push(item.path);
        if (item.children) {
            paths.push(...item.children.map(
                child => child.path ?? '').filter(Boolean)
            );
        }
        return paths;
    });

    localStorage.setItem('menu-auth', JSON.stringify(menuPaths));
}


export const menusales: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },
    {
        path: "/sales/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/master/customer",
        title: "Customer",
        icon: "Bag",
        icon1: "fill-animation",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/order-interaction",
        title: "Order Interaction",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/pos",
        title: "Point Of Sales",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },

    {
        path: "/sales/order-history",
        title: "Order History",
        icon: "Calendar",
        icon1: "fill-Calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    // {
    //     path: "/setting/user",
    //     title: "Setting User",
    //     icon: "Profile",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "badge",
    //     active: false,
    //     isPinned: false,
    // },
]

export const menuadminproduk: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },

    {
        path: "/admin/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/master/customer",
        title: "Customer",
        icon: "Bag",
        icon1: "fill-animation",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/order-interaction",
        title: "Order Interaction",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/pos",
        title: "Point Of Sales",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },

    {
        path: "/sales/order-history",
        title: "Order History",
        icon: "Calendar",
        icon1: "fill-Calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/sales-order",
        title: "Sales Order",
        icon: "Document",
        icon1: "fill-Document",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/sales-closing",
        title: "Sales Closing",
        icon: "Paper",
        icon1: "fill-file",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/comission",
        title: "Comission",
        icon: "Wallet",
        icon1: "fill-board",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/report-order",
        title: "Report Order",
        icon: "Message",
        icon1: "fill-email",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/report-comission",
        title: "Report Comission",
        icon: "Message",
        icon1: "fill-email",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/warehouse/delivery",
        title: "Warehouse Delivery",
        icon: "Wallet",
        icon1: "fill-board",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/warehouse/return",
        title: "Warehouse Return",
        icon: "Wallet",
        icon1: "fill-board",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    // {
    //     path: "/setting/user",
    //     title: "Setting User",
    //     icon: "Profile",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "badge",
    //     active: false,
    //     isPinned: false,
    // },
]

export const menuwarehouse: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },
    {
        path: "/warehouse/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/master/customer",
        title: "Customer",
        icon: "Bag",
        icon1: "fill-animation",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/order-interaction",
        title: "Order Interaction",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/pos",
        title: "Point Of Sales",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/order-history",
        title: "Order History",
        icon: "Calendar",
        icon1: "fill-Calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/sales-order",
        title: "Sales Order",
        icon: "Document",
        icon1: "fill-Document",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/warehouse/delivery",
        title: "Warehouse Delivery",
        icon: "Wallet",
        icon1: "fill-board",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/warehouse/return",
        title: "Warehouse Return",
        icon: "Wallet",
        icon1: "fill-board",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/warehouse/stockin",
        title: "Warehouse Stock In",
        icon: "Wallet",
        icon1: "fill-board",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    // {
    //     path: "/setting/user",
    //     title: "Setting User",
    //     icon: "Profile",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "badge",
    //     active: false,
    //     isPinned: false,
    // },
]

export const menufinance: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },
    {
        path: "/finance/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/sales/order-interaction",
        title: "Order Interaction",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/pos",
        title: "Point Of Sales",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },

    {
        path: "/sales/order-history",
        title: "Order History",
        icon: "Calendar",
        icon1: "fill-Calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/sales-order",
        title: "Sales Order",
        icon: "Document",
        icon1: "fill-Document",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/sales/sales-closing",
        title: "Sales Closing",
        icon: "Paper",
        icon1: "fill-file",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        title: "Warehouse",
        icon: "Wallet",
        icon1: "fill-animation",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/warehouse/delivery",
                title: "Warehouse Delivery",
                type: "link"
            },
            {
                path: "/warehouse/return",
                title: "Warehouse Return",
                type: "link"
            },
            {
                path: "/warehouse/stockin",
                title: "Warehouse Stock In",
                type: "link"
            },
        ]
    },
    {
        title: "Master",
        icon: "Category",
        icon1: "fill-animation",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/master/bank",
                title: "Bank",
                type: "link"
            },
            {
                path: "/master/customer",
                title: "Customer",
                type: "link"
            },
            {
                path: "/master/destination",
                title: "Destination",
                type: "link"
            },
            {
                path: "/master/divisi",
                title: "Divisi",
                type: "link"
            },
            {
                path: "/master/platform",
                title: "Information",
                type: "link"
            },
            {
                path: "/master/interaction",
                title: "Interaction",
                type: "link"
            },
            {
                path: "/master/item",
                title: "Item Product",
                type: "link"
            },
            {
                path: "/master/warehouse",
                title: "Warehouse",
                type: "link"
            },
            {
                path: "/master/shipping",
                title: "Shipping",
                type: "link"
            },
        ]
    },
    {
        title: "Report Order",
        icon: "Wallet",
        icon1: "fill-animation",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/sales/comission",
                title: "Comission",
                type: "link"
            },
            {
                path: "/sales/report-order",
                title: "Report Order",
                type: "link"
            },
            {
                path: "/sales/report-comission",
                title: "Report Comission",
                type: "link"
            },
        ]
    },
    {
        path: "/setting/user",
        title: "Setting User",
        icon: "Profile",
        icon1: "fill-user",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
]

export const menudefault: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },
]

export const menuroot: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },
    {
        path: "/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/sales/order-interaction",
        title: "Order Interaction",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        title: "Order",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/sales/pos",
                title: "POS",
                type: "link"
            },
            {
                path: "/sales/order-history",
                title: "Order History",
                type: "link"
            },
            {
                path: "/sales/sales-order",
                title: "Sales Order",
                type: "link"
            },
            {
                path: "/sales/sales-closing",
                title: "Sales Closing",
                type: "link"
            },
            {
                path: "/sales/comission",
                title: "Comission",
                type: "link"
            },
            {
                path: "/sales/report-order",
                title: "Report Order",
                type: "link"
            },
            {
                path: "/sales/report-comission",
                title: "Report Comission",
                type: "link"
            },
        ]
    },
    {
        title: "Warehouse",
        icon: "Work",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/warehouse/waybill-generade",
                title: "Waybill Generade",
                type: "link"
            },
            {
                path: "/warehouse/delivery",
                title: "Delivery",
                type: "link"
            },
            {
                path: "/warehouse/return",
                title: "Return",
                type: "link"
            },
            {
                path: "/warehouse/stock",
                title: "Stock",
                type: "link"
            },
        ]
    },
    {
        title: "Shipping",
        icon: "Tick-square",
        icon1: "fill-task",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/shipping/picking",
                title: "Picking",
                type: "link"
            },
            {
                path: "/shipping/courier",
                title: "Courier",
                type: "link"
            },
        ]
    },
    {
        title: "Master",
        icon: "Category",
        icon1: "fill-animation",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/master/bank",
                title: "Bank",
                type: "link"
            },
            {
                path: "/master/customer",
                title: "Customer",
                type: "link"
            },
            {
                path: "/master/destination",
                title: "Destination",
                type: "link"
            },
            {
                path: "/master/divisi",
                title: "Divisi",
                type: "link"
            },
            {
                path: "/master/engagement",
                title: "Engagement",
                type: "link"
            },
            {
                path: "/master/item",
                title: "Item Product",
                type: "link"
            },
            {
                path: "/master/warehouse",
                title: "Warehouse",
                type: "link"
            },
            {
                path: "/master/vendor",
                title: "Vendor",
                type: "link"
            },
            {
                path: "/master/purchase-destination",
                title: "Purchase Destination",
                type: "link"
            },
            {
                path: "/master/shipping",
                title: "Shipping",
                type: "link"
            },
        ]
    },
    {
        title: "Chat",
        icon: "Chat",
        icon1: "fill-chat",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/app/private_chat",
                title: "Private Chat",
                type: "link"
            },
            {
                path: "/app/group_chat",
                title: "Group Chat",
                type: "link"
            }
        ]
    },
    {
        title: "Settings",
        icon: "Setting",
        icon1: "fill-setting",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/setting/permission",
                title: "Permission",
                type: "link"
            },
            {
                path: "/setting/role",
                title: "Role",
                type: "link"
            },
            {
                path: "/setting/user",
                title: "User",
                type: "link"
            },
            {
                path: "/setting/menu",
                title: "Menu",
                type: "link"
            },
            {
                path: "/setting/template",
                title: "Template",
                type: "link"
            }
        ]
    },
]

export const menumanagement: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle"
    },
    {
        path: "/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        title: "Order",
        icon: "Bag",
        icon1: "fill-ecommerce",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/sales/pos",
                title: "POS",
                type: "link"
            },
            {
                path: "/sales/order-history",
                title: "Order History",
                type: "link"
            },
            {
                path: "/sales/sales-order",
                title: "Sales Order",
                type: "link"
            },
            {
                path: "/sales/sales-closing",
                title: "Sales Closing",
                type: "link"
            },
            {
                path: "/sales/comission",
                title: "Comission",
                type: "link"
            },
            {
                path: "/sales/report-order",
                title: "Report Order",
                type: "link"
            },
            {
                path: "/sales/report-comission",
                title: "Report Comission",
                type: "link"
            },
        ]
    },
    {
        title: "Warehouse",
        icon: "Work",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/warehouse/waybill-generade",
                title: "Waybill Generade",
                type: "link"
            },
            {
                path: "/warehouse/delivery",
                title: "Delivery",
                type: "link"
            },
            {
                path: "/warehouse/return",
                title: "Return",
                type: "link"
            },
            {
                path: "/warehouse/stock",
                title: "Stock",
                type: "link"
            },
        ]
    },
    {
        title: "Shipping",
        icon: "Tick-square",
        icon1: "fill-task",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/shipping/picking",
                title: "Picking",
                type: "link"
            },
            {
                path: "/shipping/courier",
                title: "Courier",
                type: "link"
            },
        ]
    },
    {
        title: "Master",
        icon: "Category",
        icon1: "fill-animation",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/master/bank",
                title: "Bank",
                type: "link"
            },
            {
                path: "/master/customer",
                title: "Customer",
                type: "link"
            },
            {
                path: "/master/destination",
                title: "Destination",
                type: "link"
            },
            {
                path: "/master/divisi",
                title: "Divisi",
                type: "link"
            },
            {
                path: "/master/engagement",
                title: "Engagement",
                type: "link"
            },
            {
                path: "/master/item",
                title: "Item Product",
                type: "link"
            },
            {
                path: "/master/warehouse",
                title: "Warehouse",
                type: "link"
            },
            {
                path: "/master/vendor",
                title: "Vendor",
                type: "link"
            },
            {
                path: "/master/purchase-destination",
                title: "Purchase Destination",
                type: "link"
            },
            {
                path: "/master/shipping",
                title: "Shipping",
                type: "link"
            },
        ]
    },
    {
        title: "Chat",
        icon: "Chat",
        icon1: "fill-chat",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/app/private_chat",
                title: "Private Chat",
                type: "link"
            },
            {
                path: "/app/group_chat",
                title: "Group Chat",
                type: "link"
            }
        ]
    },
    {
        title: "Settings",
        icon: "Setting",
        icon1: "fill-setting",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/setting/permission",
                title: "Permission",
                type: "link"
            },
            {
                path: "/setting/role",
                title: "Role",
                type: "link"
            },
            {
                path: "/setting/user",
                title: "User",
                type: "link"
            },
            {
                path: "/setting/menu",
                title: "Menu",
                type: "link"
            },
            {
                path: "/setting/template",
                title: "Template",
                type: "link"
            }
        ]
    },
]

export const menusalescln: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards",
        type: "headtitle"
    },
    {
        path: "/clinic/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/clinic/patient",
        title: "Pasien",
        icon: "Profile",
        icon1: "fill-user",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/schedule",
        title: "Jadwal",
        icon: "Calendar",
        icon1: "fill-calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    // {
    //     path: "/clinic/registration",
    //     title: "Registrasi",
    //     icon: "Edit",
    //     icon1: "fill-to-do",
    //     type: "sub",
    //     badgeType: "badge",
    //     active: false,
    //     isPinned: false,
    // },
    {
        path: "/clinic/report-sales",
        title: "Laporan sales",
        icon: "Chart",
        icon1: "fill-chart",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/report-closing",
        title: "Laporan Closing",
        icon: "Chart",
        icon1: "fill-chart",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    }
]
export const menuadmincln: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards",
        type: "headtitle"
    },
    {
        path: "/clinic/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/clinic/patient",
        title: "Pasien",
        icon: "Profile",
        icon1: "fill-user",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/schedule",
        title: "Jadwal",
        icon: "Calendar",
        icon1: "fill-calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/registration",
        title: "Registrasi",
        icon: "Edit",
        icon1: "fill-to-do",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/report-sales",
        title: "Laporan sales",
        icon: "Chart",
        icon1: "fill-chart",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/report-closing",
        title: "Laporan Closing",
        icon: "Chart",
        icon1: "fill-chart",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    }
]

export const menurootcln: MenuItem[] = [
    {
        headTitle1: "General",
        headTitle2: "Dashboards",
        type: "headtitle"
    },
    {
        path: "/clinic/dashboard",
        title: "Dashboard",
        icon: "Home-dashboard",
        icon1: "fill-home",
        type: "sub",
        badgeType: "badge",
        active: true,
        isPinned: false,
    },
    {
        path: "/clinic/patient",
        title: "Pasien",
        icon: "Profile",
        icon1: "fill-user",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/schedule",
        title: "Jadwal",
        icon: "Calendar",
        icon1: "fill-calendar",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        path: "/clinic/registration",
        title: "Registrasi",
        icon: "Edit",
        icon1: "fill-to-do",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
    {
        title: "Master Klinik",
        icon: "Category",
        icon1: "fill-category",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/master/response-patient",
                title: "Response Pasien",
                type: "link"
            },
            {
                path: "/master/platform",
                title: "Information",
                type: "link"
            },
        ]
    },
    {
        title: "Report",
        icon: "Chart",
        icon1: "fill-chart",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/clinic/report-sales",
                title: "Report Sales",
                type: "link"
            },
            {
                path: "/clinic/report-closing",
                title: "Report Closing",
                type: "link"
            },
        ]
    },
    {
        path: "/setting/user",
        title: "Setting User",
        icon: "Profile",
        icon1: "fill-user",
        type: "sub",
        badgeType: "badge",
        active: false,
        isPinned: false,
    },
]